import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {timer} from 'rxjs/observable/timer';
import {filter, switchMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

import {NotificationContainer, NotificationServiceBus} from './notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnDestroy, OnInit {
  show = false;
  isError = false;
  title = '';
  message = '';

  private destroy$ = new Subject<void>();

  constructor(private notificationService: NotificationServiceBus, private ngZone: NgZone) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.notificationService.launchNotification$
        .pipe(
          filter((notification: NotificationContainer) => notification && notification.message.length > 0),
          switchMap(({isError, message}: NotificationContainer) => {
            this.ngZone.run(() => {
              this.show = true;
              this.isError = isError;
              this.title = !isError ? 'Hurray! ' : 'Oops! ';
              this.message = message;
            });

            return timer(this.isError ? 10000 : 3500).pipe(
              tap(() =>
                this.ngZone.run(() => {
                  this.show = false;
                  this.title = this.message = '';
                })
              )
            );
          }),
          takeUntil(this.destroy$)
        )
        .subscribe();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/notification/notification.component.ts